
<div class="app">
  <mobile />
  <Modal v-if="modal.show || loading" class="fadeIn animated">
    <Rule v-if="modal.type === 'rule'"></Rule>
    <Bind v-if="modal.type === 'bind'"></Bind>
    <Share v-if="modal.type === 'share'"></Share>
    <Copy v-if="modal.type === 'copy'" :copy="modal.copy"></Copy>
    <Win v-if="modal.type === 'win'" :win="modal.win"></Win>
    <Times v-if="modal.type === 'times'"></Times>
    <Prize v-if="modal.type === 'prize'" :prize="modal.prize"></Prize>
    <Loading v-if="loading" />
  </Modal>
  <Orientation v-if="isMobile" />
</div>
